import { z } from 'zod';
import { ALL_SCOPES, type Scope } from '../scopes';

export const UlidSchema = z.string().regex(/^[0-7][0-9A-HJKMNP-TV-Z]{25}$/, 'Expected a ULID');
export const EpochMsSchema = z.number().int().nonnegative();
export const CentsSchema = z.number().int().nonnegative();
export const CurrencySchema = z.string().regex(/^[A-Z]{3}$/, 'ISO-4217 code');
export const HandleSchema = z
  .string()
  .regex(/^[a-z0-9][a-z0-9-]{2,38}[a-z0-9]$/, 'Handle: 4-40 chars a-z 0-9 -');
export const SlugSchema = z
  .string()
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
  .max(120);
export const EmailSchema = z.email();
export const UrlSchema = z.url({ protocol: /^https?$/ });

export const VisibilitySchema = z.enum(['public', 'connections', 'private']);
export const PersonaSchema = z.enum([
  'seeker',
  'employee',
  'employer',
  'recruiter',
  'advertiser',
  'marketer',
  'creator',
  'agent-owner',
]);
export const OrgRoleSchema = z.enum([
  'owner',
  'admin',
  'recruiter',
  'marketer',
  'advertiser',
  'member',
]);
export const EventSourceSchema = z.enum(['human', 'agent', 'ai_bot', 'search_bot']);
export const AuthProviderSchema = z.enum(['google', 'github', 'microsoft', 'linkedin']);

export const PaginationQuerySchema = z.object({
  cursor: z.string().min(1).max(512).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export function paginated<T extends z.ZodType>(item: T) {
  return z.object({ items: z.array(item), nextCursor: z.string().nullable() });
}

export const PrincipalSchema = z.object({
  kind: z.enum(['user', 'agent']),
  userId: UlidSchema,
  agentTokenId: UlidSchema.optional(),
  scopes: z.array(z.enum(ALL_SCOPES as [Scope, ...Scope[]])),
  orgIds: z.array(UlidSchema),
});
export type Principal = z.infer<typeof PrincipalSchema>;

export type Visibility = z.infer<typeof VisibilitySchema>;
export type Persona = z.infer<typeof PersonaSchema>;
export type OrgRole = z.infer<typeof OrgRoleSchema>;
export type EventSource = z.infer<typeof EventSourceSchema>;
export type AuthProvider = z.infer<typeof AuthProviderSchema>;
